"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_PASS_LEN = exports.addressRegex = exports.addressKey = exports.accountRegex = exports.accountKey = void 0;

var _util = require("@polkadot/util");

var _keyring = require("@polkadot/keyring");

// Copyright 2017-2019 @polkadot/ui-keyring authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const ACCOUNT_PREFIX = 'account:';
const ADDRESS_PREFIX = 'address:';
const MAX_PASS_LEN = 32;
exports.MAX_PASS_LEN = MAX_PASS_LEN;

function toHex(address) {
  return (0, _util.u8aToHex)((0, _keyring.decodeAddress)(address));
}

const accountKey = address => "".concat(ACCOUNT_PREFIX).concat(toHex(address));

exports.accountKey = accountKey;

const addressKey = address => "".concat(ADDRESS_PREFIX).concat(toHex(address));

exports.addressKey = addressKey;
const accountRegex = new RegExp("^".concat(ACCOUNT_PREFIX), '');
exports.accountRegex = accountRegex;
const addressRegex = new RegExp("^".concat(ADDRESS_PREFIX), '');
exports.addressRegex = addressRegex;